<template>
    <module-card>
        <p class="text-subtitle-2">Any changes you've made to your BottomLine are highlighted blue.</p>
        <v-data-table hide-default-footer disable-sort :headers="headers" :items="items" class="elevation-1" mobile-breakpoint="0">
            <template slot="item" slot-scope="props">
                <tr>
                    <td class="v-data-table__divider" v-html="props.item.statement"></td>
                    <td class="v-data-table__divider">{{ props.item.module2 }}</td>
                    <td class="v-data-table__divider" :class="{ 'updated-bottom-line': props.item.module10 != props.item.module2 }">{{ props.item.module10 }}</td>
                    <td class="v-data-table__divider" :class="{ 'updated-bottom-line': props.item.module15 != props.item.module10 }">{{ props.item.module15 }}</td>
                    <td class="v-data-table__divider" :class="{ 'updated-bottom-line': props.item.module20 != props.item.module15 }">{{ props.item.module20 }}</td>
                </tr>
            </template>
        </v-data-table>
    </module-card>
</template>

<script>
    export default {
        data() {
            return {
                bottomLineModules: [
                    {
                        id: 2,
                        name: 'BottomLine'
                    },
                    {
                        id: 10,
                        name: 'Checking in on your BottomLine'
                    },
                    {
                        id: 15,
                        name: 'Checking in on your BottomLine again'
                    },
                    {
                        id: 20,
                        name: 'Last time checking in on your BottomLine'
                    }
                ]
            };
        },
        computed: {
            myBottomLine() {
                return this.$store.get(`bottomLine`);
            },
            bottomLineStatements() {
                return this.$store.get(`content@bottomLineStatements`);
            },
            bottomLineChoices() {
                return this.$store.get(`content@bottomLineChoices`);
            },
            headers() {
                let h = [];

                let o = {
                    text: '',
                    value: 'statement',
                    align: 'start',
                    divider: 'true',
                    width: '200px'
                };

                h.push(o);

                this.bottomLineModules.forEach((el) => {
                    let o = {
                        text: el.name,
                        value: 'module' + el.id,
                        align: 'start',
                        divider: 'true',
                        width: '150px'
                    };

                    h.push(o);
                });

                return h;
            },
            items() {
                let i = [];

                Object.values(this.bottomLineStatements).forEach((el) => {
                    // for each bottom line statement, add the statement and the responses from each module
                    let o = {
                        value: false,
                        statement: el.statement,
                        module2: this.myBottomLine[2].myBottomLine[el.id].response ? this.bottomLineChoices[this.myBottomLine[2].myBottomLine[el.id].response].choice : null,
                        module10: this.myBottomLine[10].myBottomLine[el.id].response ? this.bottomLineChoices[this.myBottomLine[10].myBottomLine[el.id].response].choice : null,
                        module15: this.myBottomLine[15].myBottomLine[el.id].response ? this.bottomLineChoices[this.myBottomLine[15].myBottomLine[el.id].response].choice : null,
                        module20: this.myBottomLine[20].myBottomLine[el.id].response ? this.bottomLineChoices[this.myBottomLine[20].myBottomLine[el.id].response].choice : null
                    };

                    i.push(o);
                });

                return i;
            }
        }
    };
</script>

<style scoped>
    table > tbody > tr > td:nth-child(1) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0;
        z-index: 9998;
        background-color: white;
    }

    ::v-deep table > thead > tr > th:nth-child(1) {
        position: sticky !important;
        position: -webkit-sticky !important;
        left: 0;
        z-index: 9998;
        background-color: white;
    }

    .updated-bottom-line {
        color: darkblue;
        font-weight: bold;
    }
</style>
